import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Global self-referencing canonical tag.
 * - For most pages: sets canonical to current pathname.
 * - For refurbished product pages: SKIPS injection so RefurbishedProductPage's
 *   own Helmet-managed canonical (with proper slug-id) wins. Avoids duplicate
 *   canonical regression flagged in iter 323.
 */
const CanonicalURL = () => {
  const location = useLocation();

  useEffect(() => {
    // Skip refurbished product detail pages, they manage their own canonical via Helmet
    if (location.pathname.startsWith('/refurbished/') &&
        location.pathname !== '/refurbished/cart' &&
        location.pathname !== '/refurbished/order-success') {
      // Remove any pre-existing global canonical so Helmet's takes over cleanly
      const existing = document.querySelectorAll('link[rel="canonical"]:not([data-rh="true"])');
      existing.forEach(el => el.remove());
      return;
    }

    const baseUrl = 'https://2aelectronics.com';
    const canonicalUrl = `${baseUrl}${location.pathname}`;

    // Self-referencing canonical tag (only for non-product routes)
    let link = document.querySelector('link[rel="canonical"]:not([data-rh="true"])');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', canonicalUrl);
  }, [location.pathname]);

  return null;
};

export default CanonicalURL;
